module.exports = __webpack_public_path__ + "img/c.87da00d3.png";